import { Col, Form, InputGroup } from 'react-bootstrap';
import { FormProps } from './../../data/from-data/interface/modal-form-props.interface';
import { ChangeEvent } from 'react';

const ModalForm = ({
  formProps,
  handleInputChange
}: {
  formProps?: FormProps;
  handleInputChange: (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => void;
}) => {
  return (
    <>
      <Col sm={12} md={12}>
        <Form.Group as={Col} controlId={`${formProps?.label}`}>
          <Form.Label>{formProps?.label}</Form.Label>
          <InputGroup hasValidation>
            {formProps?.type === 'select' ? (
              <Form.Select
                name={formProps?.name}
                value={formProps?.value || ''}
                onChange={handleInputChange}
                {...(formProps?.required && { required: true })}
              >
                <option value="">Select {formProps?.label}</option>
                {formProps?.options?.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            ) : (
              <Form.Control
                type={formProps?.type}
                as={formProps?.type === 'textarea' ? 'textarea' : undefined}
                placeholder={formProps?.placeholder}
                name={formProps?.name}
                value={formProps?.value || ''}
                onChange={handleInputChange}
                {...(formProps?.required && { required: true })}
              />
            )}
            <Form.Control.Feedback type="invalid">
              Please fill this field correctly.
            </Form.Control.Feedback>
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
      </Col>
    </>
  );
};

export default ModalForm;
